import { CustomFunction } from "@ceeferenderer/itg-renderer-sdk/model/common";
import { ICustomFunctionValueType } from "@ceeferenderer/itg-renderer-sdk";
import { getTargets, getValues, notifyTargets, isFutureDate as sharedIsFutureDate } from "../../utils/dateValidation";

type DateType = "startMonth" | "startYear" | "endMonth" | "endYear";
type Values = Record<DateType, string>;

const validateDateType = (dateType: string): dateType is DateType => /^(start|end)(Month|Year)$/.test(dateType);

const isFutureDate = (dateType: DateType, values: Values): boolean => {
  const pairName = dateType.match(/^(start|end)/)?.[1] as "start" | "end";

  const month = values[`${pairName}Month` as DateType];
  const year = values[`${pairName}Year` as DateType];
  return sharedIsFutureDate(month, year);
};

const isStartAfterEnd = ({ endMonth, endYear, startMonth, startYear }: Values): boolean =>
  !!(
    endMonth &&
    endYear &&
    startMonth &&
    startYear &&
    Date.parse(`01 ${startMonth} ${startYear}`) > Date.parse(`01 ${endMonth} ${endYear}`)
  );

const isValueFilled = (value: ICustomFunctionValueType): boolean =>
  !!value && Array.isArray(value) && (value as string[]).every(Boolean);

const lock: Record<string, boolean> = {};

export const comboDate: CustomFunction = (value, _, input) => {
  const dateType = input?.getAttribute("data-date-type");
  if (!input || !dateType || !validateDateType(dateType)) {
    throw new Error();
  }
  const targets = getTargets(
    {
      endMonth: "data-end-month",
      endYear: "data-end-year",
      startMonth: "data-start-month",
      startYear: "data-start-year",
    },
    input
  );
  const values = getValues(targets);
  const lockId = targets.startMonth.getAttribute("rsmonitor") || dateType;
  if (!lock[lockId] && values.endMonth && values.endYear && values.startMonth && values.startYear) {
    lock[lockId] = true;
    notifyTargets(dateType, targets);
    lock[lockId] = false;
  }

  return {
    message: `Please select a valid ${dateType.match(/^(?:start|end)(Month|Year)$/)?.[1]} to continue`,
    value: !isFutureDate(dateType, values) && !isStartAfterEnd(values) && isValueFilled(value),
  };
};
